import { gql } from '@apollo/client';

export const GET_ALL_PLACMENTS_ACCOUNTING_DASHBOARD = gql`
  query AllPlacementListAccountingDashboard(
    $page: Int!
    $limit: Int!
    $searchText: String
    $searchActivityReport: String
    $statusSearch: String
    $myPendingActions: Boolean
    $columnFilters: AccountingPlacementColumnFilter!
  ) {
    allPlacementListAccountingDashboard(
      payload: { page: $page, limit: $limit }
      columnFilters:$columnFilters
      filters: {
        searchText: $searchText
        statusSearch: $statusSearch
        searchActivityReport:$searchActivityReport
        myPendingActions: $myPendingActions
      }
    ) {
      placements {
        id
        invoiceNumber
        jobOrderOfPlacement{
          companyId,
          id
        }
        placementId
        startDateString
        candidateName
        companyName
        paidAtString
        isPaid
        paidAt
        paymentType
        jobTitle
        netCommission
        placementStatus
        candidateFullName
        jobWorkType
        candidateId
        peopleTwoFee
        accountManager {
          fullName
        }
        jobOwner {
          fullName
        }
        recruiter {
          id
          fullName
        }
        jobApplicant {
          id
        }
        jobOrder {
          id

          company {
            id
          }
        }
        jobStreet
        jobCity
        jobCountryCode
        jobDivision
        totalCommission
        jobStateCode
        candidateCountryCode
        placementType
        candidateEmail
        startDate
        finalEndDate
        invoiceAttachment{
          activityReport
          updatedAt
        }
        createdAt
      }
      count
    }
  }
`;

export const GET_DH_COMMISSION_COVERAGE = gql`
  query DhPlacementCommissionCoverage($placementIds: [String!]!) {
    dhPlacementCommissionCoverage(placementIds: $placementIds) {
      placementId
      totalSplits
      coveredSplits
      activeCommissionCount
    }
  }
`;

// kan-98: the listing rows carry none of the sheet's money/split/agreement
// fields, so the bulk export pulls everything for the page's direct-hire
// placements in one batch.
export const GET_DH_COMMISSION_SHEET_PLACEMENTS = gql`
  query DhCommissionSheetPlacements($placementIds: [String!]!) {
    dhCommissionSheetPlacements(placementIds: $placementIds) {
      id
      placementId
      invoiceNumber
      candidateName
      jobTitle
      jobCity
      jobStateCode
      companyName
      agreementNickName
      startDateString
      createdAt
      salaryAmount
      feeStructured
      totalCommission
      adjustmentTotal
      netCommission
      splits {
        id
        splitType
        splitPercentage
        userId
        userFullName
      }
      commissions {
        id
        userId
        commissionSide
        entryType
        status
        rateType
        commissionRate
        commissionAmount
        user {
          id
          fullName
        }
      }
      # Check/wired attachments only — the Company Activity Report needs them
      # to know a placement has been paid; the commission sheet ignores them.
      payments {
        id
        attachmentType
        amount
        receivedDate
      }
    }
  }
`;

export const GET_ALL_PLACMENTS_MANAGEMENT_DASHBOARD = gql`
  query AllPlacementListManagementPage(
    $page: Int!
    $limit: Int!
    $searchText: String
    $statusSearch: String
    $myPendingActions: Boolean
    $searchActivityReport:String
    $columnFilters: PlacementColumnFilter!
  ) {
    allPlacementListManagementPage(
      payload: { page: $page, limit: $limit }
      columnFilters:$columnFilters
      filters: {
        searchText: $searchText
        statusSearch: $statusSearch
        myPendingActions: $myPendingActions
        searchActivityReport:$searchActivityReport
      }
    ) {
      placements {
        id
        placementId
        startDateString
        candidateName
        companyName
        jobTitle
        netCommission
        placementStatus
        isPaid
        candidate {
          id
          fullName
          isPrivateCandidate
        }
        peopleTwoFee
        accountManager {
          id
          fullName
        }
        recruiter {
          id
          fullName
        }
        jobOrder {
          id
          workType

          company {
            id
            name
          }
        }
        jobApplicant {
          id
        }
        jobStreet
        jobCity
        jobCountryCode
        jobDivision
        totalCommission
        jobStateCode
        placementType
        candidateEmail
        startDate
        finalEndDate
        createdAt
        invoiceAttachment{
          activityReport
          updatedAt
        }
      }
      count
    }
  }
`;

export const GET_BILLING_CONTACT = gql`
  query GetBillingContact($jobOrderId: String!) {
    billingContact(jobOrderId: $jobOrderId) {
      id
      contact {
        id
        fullName
        firstName
        jobTitle
        lastName
        companyLocation {
          id
          streetAddress
          city
          state
          country
          zipCode
        }
        contactPhone {
          id
          phoneType
          number
          isPrimary
        }
        contactEmail {
          id
          email
          isPrimary
        }
        companyLocation {
          id
          streetAddress
        }
      }
    }
  }
`;

export const GET_PLACEMENT_BY_ID = gql`
  query GetPlacementById($id: String!) {
    getPlacementById(id: $id) {
      id
      isPaid
      placementId
      supervisorPosition
      companyFirstPlacement
      statusNote
      approved
      invoiceNumber
      currentPlacementStep
      placementNote
      noteToAccounting
      companyName
      placementType
      placementStatus
      startDate
      createdAt
      startDateString
      netCommission
      feeStructured
      estimateEndDate
      replacementTerm
      payableTerm
      totalCommission
      adjustmentsReason
      adjustmentTotal
      assignmentDuration
      estimatedRecruiterProfit
      estimatedLessPayrollBurdenPercenatge
      id
      candidateName
      source
      overtimeBillRate
      billRate
      payRate
      markupPercentage
      estimatedLessPayrollBurden
      insuranceCost
      peopleTwoFee
      salaryAmount
      candidateId
      candidateFullName
      candidateFirstName
      candidateLastName
      candidateCompanyName
      candidateJobTitle
      candidateEmail
      candidateStreet
      candidateAddressOne
      candidateAddressTwo
      candidateCity
      candidateCountryCode
      candidatePostalCode
      candidateStateCode
      candidatePhone
      salaryType
      estimateEndDate
      jobTitle
      jobAllowRemote
      jobCompanyLocationId
      jobWorkType
      jobStateCode
      jobStreet
      jobCity
      jobDivision
      jobCountryCode
      jobPostalCode
      commissionType
      placementEndDate
      jobworkplaceTypes
      jobOrderOfPlacement {
        id
        company {
          id
        }
      }
      jobOrder {
        id
        workplaceTypes
        company {
          id
          name
          billBoxTag
          ownerId
          }
          jobOwner {
            id
            fullName
          }
        companyLocation {
          id
          division
        }
      }
      rejectOrApproveBy {
        id
        fullName
      }
      agreement {
        id
        nickName
      }
      candidate {
        id
        firstName
        lastName
        middleName
        postalCode
        address1
        address2
        source
      }
      jobApplicant {
        id
      }
      recruiter {
        id
        fullName
      }
      accountManager {
        id
        fullName
        email
      }
      jobOwner {
        id
        fullName
      }
      managerOfAM {
        id
        fullName
      }
      placementContacts {
        id
        companyContact {
          id
          fullName
          jobTitle
          contactEmail {
            id
            email
            isPrimary
          }
        }
        contactType
      }
      replacementId
    }
  }
`;

export const PLACEMENT_SPLITTING_BY_ID = gql`
  query PlacementSplitting($placementId: String!) {
    placementSplitting(placementId: $placementId) {
      id
      splitType
      splitPercentage
      user {
        id
        fullName
      }
    }
  }
`;
export const PAID_AT_UPDATE = gql`
  mutation paidUpdateDetails($paidUpdateDetails: paidUpdateDetails!) {
    paidUpdateDetails(paidUpdateDetails: $paidUpdateDetails) {
      message
      status
    }
  }
`;

export const ADD_INVOICE_NUMBER = gql`
  mutation addInvoiceNumber($placementId: String!, $invoiceNumber: String!) {
    addInvoiceNumber(placementId: $placementId, invoiceNumber: $invoiceNumber) {
      message
      status
    }
  }
`;